module.exports = __webpack_public_path__ + "img/ban_10.969c7a60.png";